import Services from 'fetch-decorator';
import React from 'react';
import { parse } from 'url';
import Store from '../../store';
import { BindTypes } from '../enums';
import { go, redirect } from '../location';
import fetch from '../request';

// todo: 临时解决方案, 后续还是换成openid+token的方案
// 科学的解决方法: 打开=>没有openid=>redirect静默授权=>openid查用户信息=>没有=>获取用户信息然后注册

/**
 * 用户登录/注册
 * @param code 用户信息(微信)/userId(支付宝)
 */
exports.signin = async (code) => {
  if (!code) {
    throw new Error('invalid request: missing code');
  }
  const user = await Services.auth.postUser({
    body: {
      type: window.isWechat ? 'wechat' : 'alipay',
      user: code,
    },
  });

  Store.user.login({ user });
};

/**
 * 判断用户是否已绑定相关账号
 * @param types
 * @param text
 * @param required
 * @param target
 */
exports.bindCheck = async ({ types = [], text, required = true, target } = {}) => {
  const { default: Loading } = await import('../../components/Loading');
  // 获取用户绑定
  const closeLoading = Loading.show();

  const userId = (Store.getState().user || {}).id;

  const status = {};

  if (!userId) {
    return Promise.reject('未登录');
  }

  const binds = await fetch('//user/:id/binds', {
    params: { id: userId },
  });

  types.forEach((k) => {
    status[k] = !!binds[k];
  });
  const unBindKeys = Object.keys(status).filter((k) => !status[k]);

  if (unBindKeys.length > 0 && required) {
    const { default: Dialog } = await import('../../components/Dialog');
    closeLoading();
    return Dialog({
      title: '账号未绑定',
      content: text || `${unBindKeys.map((k) => BindTypes[k]).filter((k) => !!k).join('/')} 未绑定, 点击确认前往`,
    }).then(() => {
      go({
        pathname: '/user/account',
        query: {
          redirect: encodeURIComponent(target || location.href),
          bind_required: types.join(','),
        },
      });
      return Promise.reject('账号未绑定');
    }).catch(() => {
      return Promise.reject('账号未绑定');
    });
  }
  closeLoading();

  if (unBindKeys.length < 1 && target) {
    const url = parse(target, true);
    go({
      pathname: url.pathname,
      query: url.query,
      hash: url.hash,
    });
  }
  return status;
};

/**
 * 验证用户公司信息
 * @param required
 * @param force
 */
exports.companyCheck = async (required = true, force = true) => {
  const company = await fetch('//user/company').catch((e) => {
    if (JSON.stringify(e).match(/不存在/)) {
      return {};
    }
    return Promise.reject(e);
  });

  const notExist = required === true ? !company.name : company.name === required;

  if (!force) {
    return notExist;
  }

  if (notExist) {
    const { default: Dialog } = await import('../../components/Dialog');

    return Dialog({
      title: '',
      content: <span>此停车场开通包月需要补充公司信息, 点击确认前往.<br />如有疑问请联系停车场工作人员</span>,
    }).then(() => {
      const url = parse(window.location.href, true);
      redirect({
        pathname: '/user/company',
        query: {
          redirect: url.pathname,
          plateNum: url.query.plateNum,
        },
      });

      return window.Promise.handle();
    });
  }

  return company;
};
